import { FC, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { getData, getSearchedData } from "toolkit/steps/stepSeven/stepSeven.thunks";
import { List } from "./List/List";
import { Table } from "./Table/Table";
import { ReactComponent as LoadingIcon } from "images/load.svg";
import { NoData } from "components-new/NoData/NoData";
import { IData } from "toolkit/steps/stepSeven/stepSeven.types";
import { PAGINATION_COUNT_STEP_SEVEN } from "constant";
import { SelectionControl } from "./SelectionControl/SelectionControl";
import styles from "./Content.module.sass";

export const Content: FC = () => {
	const { organizationId } = useParams();
	const scrollTargetRef = useRef<HTMLDivElement|null>(null);
	const [load, setLoad] = useState<boolean>(false);
	const dispatch = useAppDispatch();
	const {
		data,
		attachmentMode,
		tableMode,
		searchedData,
		searchMode,
		searchPending,
		searchValue,
		lastPart,
		lastSearchedPart,
	} = useAppSelector((state) => state.stepSeven);

	useEffect(() => {
		dispatch(
			getData({ organizationId: Number(organizationId), attachmentMode, part: 1, count: PAGINATION_COUNT_STEP_SEVEN }),
		);
		//eslint-disable-next-line
	}, [attachmentMode, searchMode]);

	useEffect(() => {
		if (scrollTargetRef.current) {
			scrollTargetRef.current.addEventListener("scroll", () => checkPosition());
		}

		return () => {
			// eslint-disable-next-line react-hooks/exhaustive-deps
			scrollTargetRef.current?.removeEventListener("scroll", () => checkPosition());
		};
		//eslint-disable-next-line
	}, [scrollTargetRef.current, lastPart, tableMode]);

	useEffect(() => {
		if (!searchMode && load && lastPart !== null) {
			dispatch(
				getData({
					organizationId: Number(organizationId),
					attachmentMode,
					part: lastPart + 1,
					count: PAGINATION_COUNT_STEP_SEVEN,
					setLoad: () => setLoad(false),
				}),
			);
		}

		if (searchMode && load && lastSearchedPart !== null) {
			dispatch(
				getSearchedData({
					organizationId: Number(organizationId),
					searchValue,
					attachmentMode,
					part: lastSearchedPart + 1,
					count: PAGINATION_COUNT_STEP_SEVEN,
					setLoad: () => setLoad(false),
				}),
			);
		}
		//eslint-disable-next-line
	}, [load]);

	const checkPosition = () => {
		const height = scrollTargetRef.current?.scrollHeight;
		const screenHeight = scrollTargetRef.current?.offsetHeight;
		const scrolled = scrollTargetRef.current?.scrollTop;
		if ( height && screenHeight && scrolled ) {
			const threshold = height - screenHeight;
			const position = scrolled + screenHeight;

			if (position >= threshold && !load) setLoad(true);
		}
	};

	const localData: IData = searchMode ? searchedData : data;

	return (
		<>
			{attachmentMode && <SelectionControl />}
			{searchPending ? (
				<div data-comment-false={true} className="loading-wrp">
					<LoadingIcon className="loading-icon" />
				</div>
			) : (
				<>
					{localData.assigned.length ||
					localData.unassigned.length ||
					localData.repeatable.length ||
					localData.noLetter.length ? (
						tableMode ? (
							!attachmentMode ? (
								<Table />
							) : localData.noLetter.length || localData.repeatable.length ? (
								<Table />
							) : (
								<NoData title="Ничего не найдено" />
							)
						) : (
							<div data-comment-false={true} ref={scrollTargetRef} className={styles.content}>
								{!attachmentMode && (
									<>
										{localData.assigned.length ? (
											<List title="Все данные присвоены" dataList={localData.assigned} type={"assigned"} />
										) : null}

										{localData.unassigned.length ? (
											<List
												title="Ожидает присвоения реестрового номера ФСТЭК и утверждения категории значимости"
												dataList={localData.unassigned}
												type={"unassigned"}
											/>
										) : null}
									</>
								)}
								{localData.repeatable.length ? (
									<List title="Повторное категорирование" dataList={localData.repeatable} type={"repeatable"} />
								) : null}
								{localData.noLetter.length ? (
									<List title="Нет письма" dataList={localData.noLetter} type={"noLetter"} />
								) : null}
							</div>
						)
					) : (
						<NoData title="Ничего не найдено" />
					)}
				</>
			)}
		</>
	);
};
